export enum TeamStatus {
  Active = 1,
  Deactivated = 2
}

export const TeamStatusLabels = {
  [TeamStatus.Active]: "Aktiv",
  [TeamStatus.Deactivated]: "Inaktiv"
}
